/**
 * Unified Empty State Component
 * Consistent empty state for all management pages
 */

import React from 'react';
import './UnifiedEmptyState.css';

const UnifiedEmptyState = ({
    icon,
    title,
    description,
    actions = [],
    className = ''
}) => {
    return (
        <div className={`unified-empty-state ${className}`}>
            <div className="unified-empty-icon">{icon}</div>
            <h3 className="unified-empty-title">{title}</h3>
            <p className="unified-empty-description">{description}</p>
            {actions.length > 0 && (
                <div className="unified-empty-actions">
                    {actions.map((action, index) => (
                        <button
                            key={index}
                            className={`unified-empty-action-btn ${action.variant || 'primary'}`}
                            onClick={action.onClick}
                            disabled={action.disabled}
                        >
                            {action.icon && <span className="unified-empty-action-icon">{action.icon}</span>}
                            {action.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default UnifiedEmptyState;
